export const FmsSyncEvents = {
  statusUpdated: 'Arable_FmsSyncStatusUpdatedEvent',
} as const;

export interface FmsSyncStatusUpdatedEvent {
  CustomerId: number;
  SyncStatus: 'Initiated' | 'Syncing' | 'Synced' | 'Failed' | 'NothingToSync';
  SyncTaskCode: string;
  TimeStamp: Date | string;
}
